<div class="modal-header">
    <div class="title">
        <h2 class="modal-title-prefix"><span translate="EDOKUMENT.PROMENAVOZILA.SINGULAR"></span></h2>
    </div>
    <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
    <!-- <form [formGroup]="baseFormGroup" class=""> -->
        <div class="row mt-3">
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input 
                            [Type]="'text'" 
                            [Label]="'EOTPREMNICAPREVOZ.IMEVOZACA.SINGULAR'"
                            #ytImeVozaca 
                            [ngClass]="{'is-invalid': submitted && fc.ImeVozaca.invalid}"
                            [MaxLength]="50">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.ImeVozaca.invalid">
                            <span *ngFor="let validation of errorMessages.ImeVozaca">
                                <span class="error-message" *ngIf="fc.ImeVozaca.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input [Type]="'text'" [Label]="'EOTPREMNICAPREVOZ.PREZIMEVOZACA.SINGULAR'"
                            #ytPrezimeVozaca
                            [ngClass]="{'is-invalid': submitted && fc.PrezimeVozaca.invalid}" 
                            [MaxLength]="50">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.PrezimeVozaca.invalid">
                            <span *ngFor="let validation of errorMessages.PrezimeVozaca">
                                <span class="error-message" *ngIf="fc.PrezimeVozaca.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input [Type]="'text'" 
                            [Label]="'EOTPREMNICAPREVOZ.EMAILVOZACA.SINGULAR'"
                            #ytEmailVozaca
                            [ngClass]="{'is-invalid': submitted && fc.EmailVozaca.invalid}" 
                            [MaxLength]="50">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.EmailVozaca.invalid">
                            <span *ngFor="let validation of errorMessages.EmailVozaca">
                                <span class="error-message" *ngIf="fc.EmailVozaca.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input [Type]="'text'" [Label]="'EOTPREMNICAPREVOZ.TELEFONVOZACA.SINGULAR'"
                            #ytTelefonVozaca
                            [ngClass]="{'is-invalid': submitted && fc.TelefonVozaca.invalid}" [MaxLength]="50">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.TelefonVozaca.invalid">
                            <span *ngFor="let validation of errorMessages.TelefonVozaca">
                                <span class="error-message" *ngIf="fc.TelefonVozaca.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input [Type]="'text'" [Label]="'EOTPREMNICAPREVOZ.REGISTARSKIBROJPREVOZNIKA.SINGULAR'"
                            #ytRegistarskiBrojPrevoznika
                            [ngClass]="{'is-invalid': submitted && fc.RegistarskiBrojPrevoznika?.invalid}"
                            [MaxLength]="50">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.RegistarskiBrojPrevoznika?.invalid">
                            <span *ngFor="let validation of errorMessages.RegistarskiBrojPrevoznika">
                                <span class="error-message"
                                    *ngIf="fc.RegistarskiBrojPrevoznika?.hasError(validation.type)">
                                    <span [translate]="validation.message"></span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input [Type]="'text'" [Label]="'EOTPREMNICAPREVOZ.BROJVOZACKEDOZVOLE.SINGULAR'"
                            #ytVozacBrojVozackeDozvole
                            [ngClass]="{'is-invalid': submitted && fc.VozacBrojVozackeDozvole.invalid}" [MaxLength]="50">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.VozacBrojVozackeDozvole.invalid">
                            <span *ngFor="let validation of errorMessages.VozacBrojVozackeDozvole">
                                <span class="error-message" *ngIf="fc.VozacBrojVozackeDozvole.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <!-- </form> -->
</div>

<div class="modal-footer">
    <button type="submit" class="btn btn-primary" id="btnPromenaVozila" (click)="PromenaVozila()">
        <span translate="EOTPREMNICA.PROMENAVOZILA.ACTION"></span>
        <span *ngIf="loadingSendPromenaVozila" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
    </button>
    <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span
            translate="FW.ACTION.CLOSE.ACTION"></span></button>
</div>